// Plain words for the `reason` a status-link email comes back with when it was not sent.
const NOT_SENT = {
  provider_not_configured: 'Email is not set up for this workspace.',
  frontend_url_not_set: 'The app address is not configured, so the link cannot be built.',
  send_failed: 'The email service refused it.',
};

export const whyNotSent = (reason) => (
  reason?.startsWith('recipient_blocked') ? 'That address is blocked from receiving email.' : NOT_SENT[reason] || 'It could not be sent.'
);
